import type { CryptoSwapsTranslations } from "../interfaces/cryptoSwaps";

export const cryptoSwapsTranslations: CryptoSwapsTranslations = {
  // Page chrome
  page_title: "Comprar USDT",
  page_description: "Compre USDT com seu saldo em COP e receba na sua carteira.",
  page_breadcrumb_wallets: "Carteiras",
  page_history_link: "Ver histórico",
  page_new_order: "Nova compra",

  // Organization (staff)
  org_picker_label: "Organização",
  org_picker_placeholder: "Busque por nome, e-mail ou ID",
  org_picker_loading: "Carregando organizações…",
  org_picker_empty: "Nenhuma organização corresponde",
  org_picker_searching: "Buscando…",
  org_picker_search_error: "Não foi possível buscar organizações. Tente novamente.",
  org_picker_catalog_error: "Não foi possível carregar as organizações.",
  org_picker_catalog_truncated: "Mostrando as primeiras organizações. Digite para buscar as demais.",
  org_picker_required_hint: "Escolha a organização cuja carteira será debitada.",
  org_picker_org_hint: "A compra é debitada da carteira desta organização.",
  org_picker_global_option: "Todas as organizações",
  org_picker_global_hint: "Mostrando compras de todas as organizações.",
  org_picker_filter_hint: "Mostrando apenas as compras desta organização.",

  // Availability
  pairs_load_failed: "Não foi possível carregar a compra de USDT",
  pairs_retry: "Tentar novamente",
  pairs_empty:
    "A compra de USDT não está habilitada para a sua conta. Fale com seu gerente de conta para ativá-la.",
  pair_label: "Moeda para comprar",
  pair_unavailable_title: "Compra indisponível no momento",
  pair_unavailable_not_configured: "A compra de {{asset}} ainda não está habilitada para a sua organização.",
  pair_unavailable_disabled: "A compra de {{asset}} está pausada temporariamente. Tente mais tarde.",
  pair_unavailable_generic: "A compra de {{asset}} não está disponível agora.",
  pair_unavailable_breb_key:
    "Para comprar {{asset}} sua organização precisa de uma chave Bre-B ativa: se uma compra não for concluída, os pesos são reembolsados para ela.",
  pair_breb_key_create: "Criar chave Bre-B",

  // Amounts
  amount_section_title: "Quanto você quer comprar?",
  amount_send_label: "Você paga",
  amount_receive_label: "Você recebe",
  amount_send_source: "Do seu saldo na Coloca",
  amount_pricing: "Calculando o preço…",
  amount_invalid: "Digite um valor maior que zero.",
  amount_precision: "Use no máximo {{decimals}} casas decimais.",
  amount_debit_note: "Serão debitados {{amount}} {{currency}} pelo arredondamento do preço.",
  price_line: "1 {{asset}} = {{price}} {{currency}}",
  amount_below_min: "O mínimo por compra é {{amount}} {{currency}}.",
  amount_above_max: "O máximo por compra é {{amount}} {{currency}}.",
  amount_out_of_range: "Este valor está fora dos limites por compra ({{min}} – {{max}} {{currency}}).",
  send_limits_hint: "Mín. {{min}} {{currency}} · Máx. {{max}} {{currency}} por compra",
  send_min_hint: "Mín. {{min}} {{currency}} por compra",
  send_max_hint: "Máx. {{max}} {{currency}} por compra",
  receive_limits_hint: "Se você indicar quanto receber: mín. {{min}} · máx. {{max}} {{currency}}",
  receive_min_hint: "Se você indicar quanto receber: mín. {{min}} {{currency}}",
  receive_max_hint: "Se você indicar quanto receber: máx. {{max}} {{currency}}",
  receive_below_min: "Para indicar quanto receber, o mínimo é {{amount}} {{currency}}.",
  receive_above_max: "Para indicar quanto receber, o máximo é {{amount}} {{currency}}.",
  receive_out_of_range:
    "Para indicar quanto receber, o valor deve estar entre {{min}} e {{max}} {{currency}}.",
  balance_available: "Disponível: {{amount}} {{currency}}",
  balance_loading: "Consultando saldo…",
  balance_error: "Não foi possível consultar o saldo.",
  balance_missing: "Esta organização não tem saldo em {{currency}}.",
  balance_insufficient: "Saldo insuficiente · Disponível: {{amount}} {{currency}}",
  balance_pick_org: "Escolha uma organização para ver o saldo.",

  // Destination
  destination_title: "Para qual carteira enviamos seus {{asset}}?",
  destination_network_label: "Rede",
  destination_network_only: "Única rede disponível",
  destination_address_label: "Endereço da carteira",
  destination_address_placeholder: "0x…",
  destination_address_empty_hint: "Cole o endereço da carteira que vai receber.",
  destination_address_valid: "Endereço válido para {{network}}.",
  destination_address_invalid:
    "Não é um endereço válido de {{network}}. Verifique se está completo e correto.",
  destination_network_unsupported: "Não conseguimos verificar endereços nesta rede.",
  destination_onchain_warning:
    "Confirme que a carteira aceita {{asset}} na {{network}}. Se a rede não for a mesma, os fundos são perdidos.",
  destination_compare: "Compare os primeiros e os últimos 6 caracteres com os da sua carteira.",
  concept_label: "Descrição (opcional)",
  concept_placeholder: "Ex.: Recarga de tesouraria",
  concept_too_long: "Use no máximo {{max}} caracteres.",

  // Summary ticket
  quote_ticket_title: "Resumo",
  quote_valid_for: "Preço válido por {{time}}",
  quote_expired_badge: "Preço vencido",
  quote_pricing_badge: "Calculando…",
  quote_no_price_badge: "Sem preço",
  quote_timer_label: "Tempo restante do preço",
  quote_announce_seconds: "Restam {{seconds}} segundos de preço.",
  quote_announce_expired: "O preço venceu.",
  quote_expired_title: "O preço venceu",
  quote_expired_message: "Peça um novo preço para continuar. Nenhum dinheiro foi movimentado.",
  quote_expired_action: "Obter novo preço",
  quote_retry_action: "Tentar novamente",
  quote_manual_title:
    "A cotação falhou várias vezes seguidas. Revise o valor e peça o preço quando estiver pronto.",
  quote_manual_action: "Obter preço",
  quote_summary_price: "Preço",
  quote_summary_pay: "Você paga",
  quote_summary_receive: "Você recebe",
  quote_summary_fees: "Tarifas",
  quote_summary_network: "Rede",
  fees_included: "Incluídas no preço",
  quote_submit: "Revisar compra",
  quote_submit_footnote:
    "Seu saldo na Coloca é debitado ao confirmar. Se o envio falhar, devolvemos tudo o que foi debitado.",

  // Review blocks
  block_readonly: "Seu perfil pode ver esta seção, mas não comprar.",
  block_organization: "Escolha a organização antes de cotar.",
  block_unavailable: "A compra não está disponível agora.",
  block_empty: "Digite quanto você quer pagar ou receber.",
  block_amount: "Corrija o valor para ver o preço.",
  block_pricing: "Calculando o preço…",
  block_unpriced: "Ainda sem preço. Peça novamente para continuar.",
  block_expired: "O preço venceu. Peça um novo.",
  block_balance: "Seu saldo na Coloca não cobre esta compra.",
  block_destination: "Digite um endereço de destino válido.",

  // Confirm dialog
  confirm_title: "Confirme sua compra",
  confirm_headline: "Você vai comprar {{receive}} por {{send}}",
  confirm_price: "Preço",
  confirm_fees: "Tarifas",
  confirm_network: "Rede",
  confirm_concept: "Descrição",
  confirm_destination_title: "Carteira de destino",
  confirm_checksum_ok: "Formato válido",
  confirm_acknowledge:
    "Revisei o endereço e confirmo que é uma carteira da {{network}}. Entendo que o envio não pode ser revertido.",
  confirm_expired_title: "O preço venceu",
  confirm_expired_message: "Atualize para comprar pelo preço vigente. Nenhum dinheiro foi movimentado.",
  confirm_refresh: "Atualizar preço",
  confirm_back: "Voltar",
  confirm_create: "Comprar {{asset}}",
  confirm_network_warning_title: "Somente {{network}}",
  confirm_network_warning:
    "Verifique com atenção se a carteira de destino é da {{network}}. Se o endereço pertencer a outra rede (Ethereum, Tron, Solana, Polygon…), os fundos são perdidos e não podem ser recuperados.",
  confirm_saved_wallet: "Carteira salva: {{alias}}",
  confirm_will_save_wallet: "Será salva como “{{alias}}” para próximas compras.",
  saved_wallets_label: "Carteira de destino",
  saved_wallets_new: "Novo endereço",
  saved_wallets_manage: "Gerenciar salvas",
  saved_wallets_title: "Carteiras salvas",
  saved_wallets_description: "Endereços de destino salvos pela sua organização para próximas compras.",
  saved_wallets_empty: "Não há carteiras salvas.",
  saved_wallets_delete: "Excluir",
  saved_wallets_delete_confirm: "Excluir esta carteira salva?",
  saved_wallets_delete_failed: "Não conseguimos excluir a carteira. Tente novamente.",
  saved_wallet_save_label: "Salvar esta carteira para próximas compras",
  saved_wallet_save_hint: "Vamos pedir seu código de autenticação (2FA) ao confirmar.",
  saved_wallet_alias_label: "Nome (opcional)",
  saved_wallet_alias_placeholder: "Ex. Tesouraria Binance",
  saved_wallet_alias_too_long: "Use no máximo {{max}} caracteres no nome.",
  saved_wallet_ownership_label: "De quem é esta carteira?",
  saved_wallet_ownership_own: "Da minha organização",
  saved_wallet_ownership_third_party: "De um terceiro",
  saved_wallet_holder_label: "Titular da carteira",
  saved_wallet_holder_placeholder: "Nome ou razão social",
  saved_wallet_holder_required: "Informe o titular da carteira.",
  saved_wallet_declaration:
    "Ao salvá-la você declara quem controla esta carteira. A declaração fica registrada com o seu usuário.",
  saved_wallet_owner_own: "Da sua organização",
  saved_wallet_owner_third_party: "De um terceiro: {{holder}}",
  saved_wallet_two_factor_title: "Confirme a carteira a salvar",
  saved_wallet_two_factor_description:
    "Digite o código do seu app de autenticação para salvar a carteira e continuar com a compra.",
  saved_wallet_two_factor_required:
    "Para salvar carteiras de destino você precisa ativar a autenticação em dois fatores (2FA).",
  order_creating_title: "Criando sua compra…",
  order_creating_hint: "Não feche esta janela.",
  transit_wallet: "Carteira {{currency}}",
  transit_your_wallet: "Sua wallet",
  transit_breb_key: "Sua chave Bre-B",
  transit_buy_aria:
    "Seus {{send}} saem da sua carteira, a Coloca os converte em {{receive}} e eles viajam pela {{network}} até sua wallet.",
  transit_sell_aria:
    "Seus {{send}} chegam pela {{network}}, a Coloca os converte em {{receive}} e os paga na sua chave Bre-B.",

  // Errors
  error_unconfirmed:
    "Não conseguimos confirmar se a compra foi criada. Verifique o histórico antes de tentar de novo, para não comprar duas vezes.",
  error_unconfirmed_history: "Ver histórico",
  error_network: "Sem conexão. Verifique sua rede e tente novamente.",
  error_service_unavailable: "O serviço não está disponível no momento. Tente em alguns minutos.",
  error_price_unavailable: "Não conseguimos obter um preço agora. Tente novamente em alguns segundos.",
  error_verification_required: "Sua organização precisa concluir a verificação antes de comprar.",
  error_forbidden: "Você não tem permissão para esta operação.",
  error_breb_key_required:
    "Para comprar cripto sua organização precisa de uma chave Bre-B ativa: os reembolsos são enviados para ela.",
  error_otc_not_enabled:
    "Cripto não está ativo para a sua organização. Entre em contato com o suporte para ativá-lo.",
  error_conflict: "Esta cotação já foi usada ou a compra ainda está em processamento. Verifique o histórico.",
  error_not_found: "Não encontramos o que você procura.",
  error_quote_expired: "O preço venceu antes da confirmação. Mostramos um novo.",
  error_rejected: "Não foi possível processar a solicitação. Revise os dados e tente novamente.",
  error_unknown: "Algo deu errado. Tente novamente.",

  // Statuses
  status_created: "Criada",
  status_processing: "Em processamento",
  status_paid: "Entregue",
  status_failed: "Falhou",
  status_cancelled: "Cancelada",
  status_reversed: "Revertida",
  filter_all: "Todas",

  // History
  history_title: "Histórico de compras",
  history_description: "Suas compras de USDT, com o status de entrega e o hash de cada transação.",
  history_export: "Exportar CSV",
  history_export_empty: "Não há compras para exportar com estes filtros.",
  history_load_error: "Não foi possível carregar o histórico.",
  history_refresh: "Atualizar",
  history_count_one: "{{count}} compra",
  history_count_other: "{{count}} compras",
  history_filter_group: "Filtrar por status",
  history_range_label: "Período",
  history_range_placeholder: "Qualquer data",

  // Table
  table_col_date: "Data",
  table_col_operation: "Compra",
  table_col_destination: "Destino",
  table_col_status: "Status",
  table_empty_title: "Ainda não há compras",
  table_empty_description: "Quando você comprar USDT, ela aparecerá aqui.",
  table_no_results_title: "Nenhuma compra corresponde",
  table_no_results_description: "Tente outro status ou período.",

  // Drawer
  drawer_title: "Compra de USDT",
  drawer_created_updated: "Criada {{created}} · Atualizada {{updated}}",
  drawer_open_order_page: "Abrir compra",
  drawer_not_found:
    "Não encontramos essa compra. Ela pode ser de outra organização ou o link está incompleto.",
  drawer_not_found_dismiss: "Fechar aviso",

  // Summary
  summary_title: "Detalhes",
  summary_debited: "Debitado",
  summary_received: "Entregue",
  summary_price: "Preço",
  summary_fees: "Tarifas",
  summary_network: "Rede",
  summary_address: "Endereço",
  summary_tx_hash: "Hash da transação",
  summary_tx_pending: "Disponível quando for enviada",
  eta_label: "Tempo estimado",
  eta_short: "≈ {{minutes}} min",
  eta_estimate: "Tempo estimado: ≈ {{minutes}} min",
  eta_running: "Em andamento",
  eta_remaining: "faltam ~{{time}}",
  eta_elapsed: "{{time}} decorrido",
  eta_progress_label: "Progresso em relação ao tempo estimado",
  eta_late:
    "Está demorando um pouco mais do que o estimado. Continua em andamento; você não precisa fazer nada.",
  eta_trend_slower: "Hoje as operações estão demorando mais do que o normal.",
  eta_trend_slower_short: "Mais lento que o normal",
  summary_view_explorer: "Ver no {{explorer}}",
  summary_concept: "Descrição",
  summary_created: "Criada",
  summary_paid_at: "Entregue",
  summary_failed_at: "Falhou",
  summary_order_id: "ID da compra",

  // Order page
  order_breadcrumb: "Compra de USDT",
  order_not_found_title: "Não encontramos esta compra",
  order_not_found_description: "Ela pode ser de outra organização ou o link está incompleto.",
  order_back_to_history: "Ir para o histórico",
  order_headline_live: "Enviando {{amount}}",
  order_headline_paid: "{{amount}} entregues",
  order_headline_failed: "Não conseguimos entregar {{amount}}",
  order_subtitle: "Para {{address}} na {{network}}.",
  order_live_title: "Atualizando ao vivo",
  order_live_updated: "Última atualização {{time}}",
  order_live_stale: "Não conseguimos atualizar o status. O que você vê pode estar desatualizado.",
  order_view_history: "Ver histórico",
  outcome_live_title: "A caminho",
  outcome_live_message:
    "Estamos enviando seu {{currency}} pela {{network}}. Esta página se atualiza sozinha; o hash aparece quando a transação sair.",
  outcome_paid_title: "Entregue",
  outcome_failed_title: "Não foi possível entregar",
  outcome_failed_message:
    "O envio não foi concluído. Devolvemos ao seu saldo na Coloca tudo o que foi debitado, tarifas incluídas.",
  outcome_failed_returned: "Devolvido ao seu saldo na Coloca",
  outcome_to_address: "Para o endereço na {{network}}",

  // Timeline
  timeline_title: "Acompanhamento",
  timeline_created: "Compra criada",
  timeline_processing: "Enviando",
  timeline_processing_hint: "A transação está em andamento.",
  timeline_delivered: "Entregue",
  timeline_failed: "Falhou e foi reembolsada",
  timeline_state_done: "concluído",
  timeline_state_current: "em andamento",
  timeline_state_todo: "pendente",
  timeline_state_failed: "falhou",

  // CSV
  csv_filename: "compras-usdt",
  csv_col_id: "ID",
  csv_col_created_at: "Data de criação",
  csv_col_status: "Status",
  csv_col_send_amount: "Valor debitado",
  csv_col_send_currency: "Moeda debitada",
  csv_col_receive_amount: "Valor entregue",
  csv_col_receive_currency: "Moeda entregue",
  csv_col_price: "Preço",
  csv_col_fee_conversion: "Tarifa de conversão",
  csv_col_fee_delivery: "Tarifa de envio",
  csv_col_network: "Rede",
  csv_col_address: "Endereço de destino",
  csv_col_tx_hash: "Hash da transação",
  csv_col_concept: "Descrição",
  csv_col_paid_at: "Data de entrega",
  csv_col_failed_at: "Data da falha",

  // Copy
  copy_done: "{{field}} copiado",
  copy_failed: "Não foi possível copiar. Selecione o texto e copie manualmente.",
  copy_address: "Endereço",
  copy_tx_hash: "Hash da transação",
  copy_order_id: "ID da compra",

  // Sell — page chrome
  sell_page_title: "Vender USDT",
  sell_page_description: "Envie USDT da sua wallet e receba pesos na sua carteira COP.",
  sell_page_new: "Nova venda",
  sell_org_picker_required_hint: "Escolha a organização que vende.",
  sell_org_picker_org_hint: "Os pesos são creditados na carteira COP desta organização.",

  // Sell — availability
  sell_pairs_load_failed: "Não conseguimos carregar a venda de USDT",
  sell_pairs_empty:
    "A venda de USDT não está habilitada para a sua conta. Fale com o seu gerente de conta para ativá-la.",
  sell_unavailable_title: "Venda indisponível no momento",
  sell_unavailable_not_configured: "A venda de {{asset}} ainda não está habilitada para a sua organização.",
  sell_unavailable_disabled: "A venda de {{asset}} está pausada temporariamente. Tente mais tarde.",
  sell_unavailable_generic: "A venda de {{asset}} não está disponível agora.",
  sell_unavailable_breb_key:
    "Para vender {{asset}} a sua organização precisa de uma chave Bre-B ativa: os pesos da venda são pagos nela.",

  // Sell — amounts
  sell_amount_title: "Quanto você quer vender?",
  sell_amount_send_label: "Você vende",
  sell_amount_receive_label: "Recebe na sua chave Bre-B",
  sell_send_limits_hint: "Mín. {{min}} {{currency}} · Máx. {{max}} {{currency}} por venda",
  sell_send_min_hint: "Mín. {{min}} {{currency}} por venda",
  sell_send_max_hint: "Máx. {{max}} {{currency}} por venda",
  sell_amount_below_min: "A venda mínima é de {{amount}} {{currency}}.",
  sell_amount_above_max: "A venda máxima é de {{amount}} {{currency}}.",
  sell_amount_out_of_range: "Este valor está fora dos limites por venda ({{min}} – {{max}} {{currency}}).",

  // Sell — network
  buy_network_title: "Em qual rede você quer receber?",
  buy_network_hint:
    "Escolha a rede da wallet que recebe: se a wallet não estiver nessa rede, os USDT não chegam.",
  access_check_failed: "Não conseguimos verificar se Cripto está ativo para a sua organização.",
  access_check_retry: "Tentar novamente",
  saved_wallet_default_alias: "Carteira {{start}}…{{end}}",
  sell_network_title: "Por qual rede você envia?",
  sell_network_hint: "Escolha a mesma rede da sua wallet: por outra rede o envio não chega.",
  sell_network_option: "{{standard}} · taxa de rede em {{gas}}",

  // Sell — wallet the deposit comes from
  sell_refund_title: "Para qual wallet devolvemos os USDT?",
  sell_refund_hint: "Se a venda não for concluída, devolvemos os {{asset}} para esta wallet.",
  sell_refund_saved_label: "Sua wallet",
  sell_refund_address_label: "Endereço da sua wallet",
  sell_refund_address_empty_hint:
    "Cole o endereço da sua wallet nesta rede. Se você enviar de uma exchange, pode ser o seu endereço de depósito nessa exchange.",
  sell_refund_warning:
    "Vai enviar de uma exchange? Some a taxa de saque dela: precisa chegar exatamente o valor da venda, ou a venda pode não ser concluída.",
  sell_refund_save_label: "Salvar esta wallet para próximas vendas",
  sell_saved_wallet_two_factor_description:
    "Digite o código do seu app autenticador para salvar a wallet e continuar com a venda.",

  // Sell — key the pesos are paid to
  sell_payout_title: "Os pesos são pagos na sua chave Bre-B principal",
  sell_payout_note: "E creditados na sua carteira COP da Coloca.",

  // Sell — summary ticket
  sell_ticket_net: "Chega à sua carteira COP",
  sell_ticket_send: "Você envia",
  sell_ticket_proceeds: "Pagamento na sua chave Bre-B",
  sell_ticket_fee: "Comissão",
  sell_ticket_fee_none: "Sem comissão",
  sell_submit: "Revisar venda",
  sell_submit_footnote:
    "Nada se move até você enviar os USDT. Se a venda não for concluída, devolvemos para a sua wallet.",

  // Sell — review blocks
  sell_block_readonly: "O seu perfil pode ver esta seção, mas não vender.",
  sell_block_unavailable: "A venda não está disponível agora.",
  sell_block_empty: "Digite quanto você quer vender ou receber.",
  sell_block_refund: "Digite o endereço da wallet para a qual devolvemos os USDT.",

  // Sell — confirm dialog
  sell_confirm_title: "Confirme a sua venda",
  sell_confirm_headline: "Você vai vender {{send}} e receber {{receive}}",
  sell_confirm_rules_title: "Como enviar os USDT",
  sell_rule_network_title: "Só {{asset}} pela {{network}}",
  sell_rule_network: "Token {{standard}}; a taxa de rede é paga em {{gas}}. Contrato:",
  sell_rule_exact_title: "Exatamente {{amount}}",
  sell_rule_exact: "Em uma única transferência. Um valor diferente pode impedir que a venda seja concluída.",
  sell_rule_wallet_title: "De uma exchange? Some a taxa",
  sell_rule_wallet:
    "A exchange desconta a taxa de saque do valor: saque o necessário para que cheguem exatamente {{amount}}.",
  sell_confirm_refund_title: "Wallet de devolução",
  sell_confirm_network_warning:
    "Envie só {{asset}} pela {{network}}. Se você enviar outra moeda ou usar outra rede (Ethereum, Tron, Solana…), os fundos podem ser perdidos.",
  sell_confirm_acknowledge:
    "Vou fazer chegar exatamente {{amount}} pela {{network}}, em uma única transferência.",
  sell_confirm_create: "Criar venda",
  sell_confirm_will_save_wallet: "Será salva como “{{alias}}” para próximas vendas.",
  sell_creating_title: "Criando a sua venda…",

  // Sell — errors
  sell_error_unconfirmed:
    "Não conseguimos confirmar se a venda foi criada. Confira as suas vendas: se aparecer, envie para o endereço que ela mostra; se não, peça um preço novo.",
  sell_error_not_created:
    "Não conseguimos criar a venda e nada se moveu. Mostramos um preço novo para tentar de novo.",
  sell_error_conflict:
    "Esta cotação já foi usada, ou você já tem uma venda aguardando depósito. Confira as suas vendas.",
  sell_error_verification_required: "A sua organização precisa concluir a verificação antes de vender.",
  sell_error_breb_key_required:
    "Para vender cripto a sua organização precisa de uma chave Bre-B ativa: os pesos são pagos nela.",
  sell_error_history: "Ver minhas vendas",

  // Sell — statuses
  sell_status_awaiting_deposit: "Aguardando depósito",
  sell_status_processing: "Processando",
  sell_status_cop_sent: "Pesos enviados",
  sell_status_completed: "Creditada",
  sell_status_expired: "Vencida",
  sell_status_refunding: "Devolvendo",
  sell_status_refunded: "Devolvida",

  // Sell — sale page
  sell_order_breadcrumb: "Venda de USDT",
  sell_order_not_found_title: "Não encontramos esta venda",
  sell_headline_awaiting: "Envie {{amount}}",
  sell_headline_processing: "Recebemos os seus {{asset}}",
  sell_headline_cop_sent: "Os seus pesos estão a caminho",
  sell_headline_completed: "Creditamos {{amount}}",
  sell_headline_expired: "A venda venceu",
  sell_headline_refunding: "Estamos devolvendo os seus {{asset}}",
  sell_headline_refunded: "Devolvemos os seus {{asset}}",
  sell_subtitle: "Os pesos são pagos na sua chave {{key}} e creditados na sua carteira COP.",

  // Sell — deposit slip
  sell_deposit_title: "Envie os seus USDT para este endereço",
  sell_deposit_qr_alt: "QR code do endereço de depósito na {{network}}",
  sell_deposit_amount: "Valor exato",
  sell_deposit_address: "Endereço de depósito",
  sell_deposit_network: "Rede",
  sell_deposit_contract: "Contrato {{asset}}:",
  sell_deposit_copy_amount: "Copiar valor",
  sell_deposit_copy_address: "Copiar endereço",
  sell_view_on_explorer: "Ver no {{explorer}}",
  sell_deposit_steps_title: "Como enviar pela MetaMask",
  sell_deposit_step_network: "Mude a MetaMask para a rede {{network}}.",
  sell_deposit_step_send: "Escolha {{asset}}, toque em Enviar e cole o endereço de depósito.",
  sell_deposit_step_amount:
    "Digite exatamente {{amount}} e confirme. Você precisa de {{gas}} para a taxa de rede.",
  sell_deposit_step_wait: "Volte aqui: esta página se atualiza sozinha quando o seu depósito chegar.",
  sell_deposit_warning:
    "Só {{asset}} pela {{network}}, em uma única transferência e da sua wallet. Outra moeda, outra rede, um valor diferente ou um envio atrasado ou dividido não são associados à sua venda e não são devolvidos automaticamente: recuperá-los é um processo manual com o suporte.",
  sell_deposit_window:
    "Você tem 15 minutos. Este endereço é só para esta venda: não o salve nem o reutilize, porque depois ele é atribuído a outras operações e um depósito atrasado ou repetido não é associado à sua venda.",
  sell_deposit_time_left: "Vence em {{time}}",
  sell_deposit_expired_title: "O tempo para depositar acabou",
  sell_deposit_expired_text:
    "Não envie nada para este endereço: ele não está mais associado à sua venda. Se você já enviou, aguarde aqui: a página se atualiza sozinha.",
  sell_deposit_unavailable_title: "Endereço de depósito indisponível",
  sell_deposit_unavailable_text:
    "Não envie nada ainda: agora não conseguimos mostrar um endereço válido para esta venda. A página se atualiza sozinha.",
  sell_deposit_tx_link: "Ver depósito no {{explorer}}",
  copy_deposit_amount: "Valor",
  copy_deposit_address: "Endereço de depósito",
  copy_sale_id: "ID da venda",

  // Sell — outcome
  sell_outcome_processing_title: "Depósito recebido",
  sell_outcome_processing_message:
    "Recebemos os seus {{asset}}. Estamos pagando os pesos na sua chave Bre-B; esta página se atualiza sozinha.",
  sell_outcome_cop_sent_title: "Pesos enviados",
  sell_outcome_cop_sent_message:
    "Pagamos {{amount}} na sua chave {{key}}. Creditamos na sua carteira COP em alguns minutos.",
  sell_outcome_completed_title: "Creditado",
  sell_outcome_completed_message: "Creditamos {{amount}} na sua carteira COP.",
  sell_outcome_wallet_link: "Ir para carteiras",
  sell_outcome_expired_title: "A venda venceu",
  sell_outcome_expired_message:
    "Não recebemos o seu depósito a tempo. Não envie {{asset}} para esse endereço. Se você já enviou, continuamos verificando: se chegarem, a venda continua ou devolvemos para a sua wallet.",
  sell_outcome_refunding_title: "Devolução em andamento",
  sell_outcome_refunding_to: "Estamos devolvendo os seus {{asset}} para",
  sell_outcome_refunded_title: "Devolvemos os seus {{asset}}",
  sell_outcome_refunded_to: "Devolvemos os seus {{asset}} para",

  // Sell — why a sale did not complete
  sell_reason_payment_timeout: "Não recebemos o depósito a tempo.",
  sell_reason_compliance: "O depósito não passou na revisão de compliance.",
  sell_reason_limit: "O valor excede os limites da operação.",
  sell_reason_payout_failed: "Não conseguimos pagar os pesos na sua chave Bre-B.",
  sell_reason_refund_pending: "Estamos providenciando a devolução para a sua wallet.",
  sell_reason_generic: "A venda não pôde ser concluída.",

  // Sell — timeline
  sell_timeline_created: "Venda criada",
  sell_timeline_awaiting: "Aguardando o seu depósito",
  sell_timeline_received: "Depósito recebido",
  sell_timeline_paying: "Pagando os pesos na sua chave",
  sell_timeline_cop_sent: "Pesos pagos na sua chave",
  sell_timeline_crediting: "Creditando na sua carteira COP",
  sell_timeline_credited: "Creditado na sua carteira COP",
  sell_timeline_expired: "Venceu sem depósito",
  sell_timeline_refunding: "Devolvendo para a sua wallet",
  sell_timeline_refunded: "Devolvido para a sua wallet",

  // Sell — summary
  sell_summary_deposit: "Depósito",
  sell_summary_proceeds: "Pago na sua chave Bre-B",
  sell_summary_fee: "Comissão",
  sell_summary_credited: "Creditado",
  sell_summary_pending: "Pendente",
  sell_summary_deposit_tx: "Hash do depósito",
  sell_summary_deposit_pending: "Disponível quando chegar",
  sell_summary_payout_key: "Chave Bre-B",
  sell_summary_refund_wallet: "Wallet de devolução",
  sell_summary_completed_at: "Creditada",
  sell_summary_expired_at: "Vencida",
  sell_summary_refunded_at: "Devolvida",
  sell_summary_refund_tx: "Transação de devolução",
  sell_refund_tx_link: "Ver devolução no {{explorer}}",
  sell_summary_sale_id: "ID da venda",

  // History — purchases and sales
  history_hub_title: "Histórico",
  history_hub_description: "As suas compras e vendas de USDT, com o status e o hash de cada transação.",
  history_tab_buys: "Compras",
  history_tab_sells: "Vendas",
  sell_history_count_one: "{{count}} venda",
  sell_history_count_other: "{{count}} vendas",
  sell_history_export_empty: "Não há vendas para exportar com estes filtros.",
  sell_history_load_error: "Não conseguimos carregar as suas vendas.",
  sell_table_col_operation: "Venda",
  sell_table_empty_title: "Ainda não há vendas",
  sell_table_empty_description: "Quando você vender USDT, aparecerá aqui.",
  sell_table_no_results_title: "Nenhuma venda corresponde",
  sell_drawer_title: "Venda de USDT",
  sell_drawer_open: "Abrir venda",
  sell_drawer_not_found:
    "Não encontramos essa venda. Pode ser de outra organização ou o link está incompleto.",

  // Sell — CSV
  sell_csv_filename: "vendas-usdt",
  sell_csv_col_deposit_amount: "Valor depositado",
  sell_csv_col_deposit_currency: "Moeda depositada",
  sell_csv_col_deposit_tx: "Hash do depósito",
  sell_csv_col_proceeds: "Pago na chave",
  sell_csv_col_fee: "Comissão",
  sell_csv_col_credited: "Creditado",
  sell_csv_col_currency: "Moeda creditada",
  sell_csv_col_payout_key: "Chave Bre-B",
  sell_csv_col_refund_wallet: "Wallet de devolução",
  sell_csv_col_completed_at: "Data de crédito",
  sell_csv_col_refunded_at: "Data de devolução",
  // Volume discount
  volume_title: "Quanto mais você compra, mais barato o dólar",
  volume_meter_label: "Desconto por volume",
  volume_meter_saving: "Você paga {{amount}} a menos por dólar do que na compra mínima.",
  volume_meter_minimum: "O preço por dólar cai à medida que você compra mais.",
  volume_meter_best: "Você já tem praticamente o melhor preço.",
  volume_suggestion_amount: "Compre {{amount}}",
  volume_suggestion_wallet: "Compre todo o seu saldo · {{amount}}",
  volume_suggestion_max: "Compre o máximo · {{amount}}",
  volume_suggestion_price: "{{price}} por dólar · {{savings}} a menos",
  volume_suggestion_price_only: "{{price}} por dólar",
  volume_suggestion_extra: "+{{amount}} extra",
  volume_top_up: "Com {{amount}} você pagaria {{price}} por dólar.",
  volume_top_up_action: "Recarregar carteira",
  volume_insufficient_title: "Você não tem saldo suficiente",
  volume_insufficient_text:
    "Com {{amount}} você receberia um desconto de {{savings}} por dólar sobre a compra mínima.",
  volume_insufficient_wallet: "Compre com todo o seu saldo · {{amount}}",
  volume_sell_title: "Quanto mais você vende, mais pesos por dólar",
  volume_sell_meter_saving: "Você recebe {{amount}} a mais por dólar do que na venda mínima.",
  volume_sell_meter_minimum: "Você recebe mais pesos por dólar à medida que vende mais.",
  volume_sell_suggestion_amount: "Venda {{amount}}",
  volume_sell_suggestion_price: "{{price}} por dólar · {{savings}} a mais",
};
